import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {computed} from 'vue';
import {WidgetStore} from "~/chat/ts/store/Widget";
import ChatModalMessage from "~/chat/vue/widget/ChatModalMessage.vue";
import ReviewFormContent from "~/chat/vue/widget/tabs/reviews/ReviewFormContent.vue";
import {ConfigStore} from "~/chat/ts/store/Config";


const __default__ = {
    name: "ReviewForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let visible = computed(() => {
    return WidgetStore.sendReviewOpened.value && !!WidgetStore.reviewsTab.value;
});

let buttonText = computed(() => {
    return ConfigStore.siteParams.value.params.rate.leaveRateButtonText;
});

function onVisibleUpdate(value: boolean) {
    if (!value) {
        WidgetStore.closeSendReview();
    }
}

return (_ctx: any,_cache: any) => {
  return (_unref(visible))
    ? (_openBlock(), _createBlock(ChatModalMessage, {
        key: 0,
        visible: _unref(visible),
        "onUpdate:visible": onVisibleUpdate,
        title: _unref(buttonText)
      }, {
        default: _withCtx(() => [
          _createVNode(ReviewFormContent)
        ]),
        _: 1
      }, 8, ["visible", "title"]))
    : _createCommentVNode("", true)
}
}

})